<h1 id="title" class="title">{{ 'Common.Application.name' | translate }}</h1>
<p class="sub-title">{{ 'Auth.Login.welcome' | translate }}</p>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title">
    <strong>{{ 'Common.Error.title' | translate }}</strong>
  </p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title">
    <strong>{{ 'Common.Success.title' | translate }}</strong>
  </p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label class="label" for="input-email">{{ 'Auth.Login.email' | translate }}</label>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.email"
      #email="ngModel"
      name="email"
      id="input-email"
      pattern=".+@.+\..+"
      [placeholder]="'Auth.Login.email' | translate"
      autofocus
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.email.required')"
      [attr.aria-invalid]="email.invalid && email.touched ? true : null"
    />
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="error-message" *ngIf="email.errors?.required">{{ 'Auth.Login.emailRequired' | translate }}</p>
      <p class="error-message" *ngIf="email.errors?.pattern">{{ 'Auth.Login.emailReal' | translate }}</p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-password">{{ 'Auth.Login.password' | translate }}</label>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.password"
      #password="ngModel"
      name="password"
      type="password"
      id="input-password"
      [placeholder]="'Auth.Login.password' | translate"
      [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.password.required')"
      [minlength]="getConfigValue('forms.validation.password.minLength')"
      [maxlength]="getConfigValue('forms.validation.password.maxLength')"
      [attr.aria-invalid]="password.invalid && password.touched ? true : null"
    />
    <ng-container *ngIf="password.invalid && password.touched">
      <p class="error-message" *ngIf="password.errors?.required">{{ 'Auth.Login.passwordRequired' | translate }}</p>
      <p class="error-message" *ngIf="password.errors?.minlength || password.errors?.maxlength">
        {{
          'Auth.Login.passwordLength'
            | translate
              : {
                  minLength: getConfigValue('forms.validation.password.minLength'),
                  maxLength: getConfigValue('forms.validation.password.maxLength')
                }
        }}
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.isAdmin"
      #isAdmin="ngModel"
      name="isAdmin"
      type="text"
      style="visibility: hidden"
      id="input-isAdmin"
      defaultValue="dwadwa"
    />
  </div>

  <!-- <div class="form-control-group accept-group">
    <nb-checkbox name="rememberMe" [(ngModel)]="user.rememberMe" *ngIf="rememberMe">Remember me</nb-checkbox>
  </div> -->

  <button nbButton fullWidth status="success" [disabled]="submitted || !form.valid" [class.btn-pulse]="submitted">
    {{ 'Auth.Login.login' | translate }}
  </button>
</form>
